module.exports = __webpack_public_path__ + "static/media/search_origin.6eecf8d2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/flavours/pickMeUp/images/search_origin.svg
// module id = 540
// module chunks = 0